const _ = require('lib/underscore')
const Radio = require('backbone.radio')
const funnels = require('lib/funnels')
const Query = require('lib/query')
const log = require('log').create('data warehouse')

class DataWarehouse {
    constructor(globals) {
        this.globals = globals
        this.funnel_state = funnels.getFunnelSummary()

        // This value is used to allow every event through for a given channel
        // Backbone.Radio also recognizes this.
        const all = 'all'

        // This is for listening to Backbone.Radio events and translating them
        // into Data Warehouse custom events
        const channels = {
            metrics: all,
            metrics_nav: all,
            metrics_signup: all,
            metrics_profile: all,
            metrics_editpanel: all,
            metrics_upgrade_page: all,
            metrics_upgrade_modal: all,
            email_signature: all,
            abtest: all,
        }

        Object.keys(channels).forEach((channel_name) => {
            const channel = Radio.channel(channel_name)
            const channel_log = log.create('data warehouse', channel_name, '#333')

            channel.on(all, (event_name, properties = {}) => {
                // First check if we're either absorbing all events for a given
                // channel or if the event name has been whitelisted in the
                // given channel's array.
                const applicable = (
                    channels[channel_name] === all
                    || _.contains(channels[channel_name], event_name)
                )

                if (! applicable) return

                const e = {
                    category: channel_name,
                    name: event_name,
                    properties,
                }

                // attach funnel state to the properties for each metric event
                // but not to funnel events on the abtest channel
                if (channel_name !== 'abtest') {
                    e.funnel_state = this.funnel_state
                }

                const url = this.getEventTrackingUrl(e)

                // Creating a new image object actually triggers the GET request
                // without needing to add/remove an img tag from the DOM.

                // eslint-disable-next-line no-unused-vars
                const img = (new Image()).src = url

                channel_log(e.name, properties)

            })
        })
    }

    getEventTrackingUrl(event) {
        const url = `${this.globals.DATA_WAREHOUSE_API}/track`

        const params = {
            category: event.category,
            name: event.name,
            auth: this.globals.AUTH_TOKEN,
        }

        // prefix all event names on mapped domains with `mapped:`
        if (this.globals.MAPPED) {
            params.name = `mapped:${params.name}`
        }

        if (event.properties) {
            params.props = JSON.stringify(event.properties)
        }

        if (event.funnel_state) {
            params.funnel_state = JSON.stringify(event.funnel_state)
        }

        // Username will be retrieved from the secure cookie on the server side
        // of this request if possible, no need to include it.

        const query = Query.stringify(params)

        return `${url}?${query}`
    }
}

module.exports = DataWarehouse
